module.exports = __webpack_public_path__ + "img/edelstahlpflanzgefaess.c86db562.webp";